import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

import { HrAssistantComponent } from '@core/intelligence-smart-ui';
import {
  TellentAdoptedStylesheetsDirective,
  TellentAppShellComponent,
  TellentThemeDirective,
} from '@core/tellent-smart-ui';
import { InputSignalLike, TellentWebComponent } from '@core/tellent-types';

@Component({
  selector: 'x-app-shell',
  template: `
    <tlc-app-shell [isMobile]="isMobile()" [isMinimalLayout]="isMinimalLayout()">
      <ng-container ngProjectAs="banner">
        <slot name="banner"></slot>
      </ng-container>

      <ng-container ngProjectAs="topbar-start-label">
        <slot name="topbar-start-label"></slot>
      </ng-container>

      <ng-container ngProjectAs="topbar-center">
        <slot name="topbar-center"></slot>
      </ng-container>

      <ng-container ngProjectAs="topbar-end">
        <slot name="topbar-end"></slot>
      </ng-container>

      <ng-container ngProjectAs="main">
        <slot name="main"></slot>
      </ng-container>

      <ng-container ngProjectAs="bottom-bar">
        <slot name="bottom-bar"></slot>
      </ng-container>
    </tlc-app-shell>
  `,
  styleUrls: ['../../../styles.less'],
  styles: `
    :host {
      display: contents;
    }
  `,
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  imports: [TellentAppShellComponent, HrAssistantComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentAppShellWrapComponent {
  // NOTE: debug purposes, leave it for now
  // @ts-ignore
  // public isMobile = signal(
  //   JSON.parse(new URLSearchParams(location.href.split('?').pop()).get('mobile')!),
  // );

  public isMobile: InputSignalLike<boolean> = input<boolean>(false);
  public isMinimalLayout: InputSignalLike<boolean> = input<boolean>(false);
}

export type TellentAppShellWebComponent = TellentWebComponent<
  TellentAppShellWrapComponent,
  'isMobile' | 'isMinimalLayout'
>;
